//@ts-nocheck
import { useMemo } from 'react';
import type { MOBILE_HANDOFF_TYPES } from '../constants/stringConstants';
import { downloadFileFromUrl } from './urlUtils';
import { logError } from '@zg-rentals/log-error';
import { TextButton, Toast } from '@zillow/constellation-10';
import { DOWNLOAD_TOAST_MESSAGES, ZILLOW_LEASES_HELP } from '../constants/stringConstants';

export const ACCEPTED_HOST_APPS = ['ios', 'android'];
export const ACCEPTED_FROM_APPS = ['ipad', 'iphone', 'android'];
const searchParams = new URLSearchParams(window.location.search);

export function onPrepareForLeaseSigningMobileHandoff(step: MOBILE_HANDOFF_TYPES) {
  //iOS
  if (window.webkit != undefined) {
    if (window.webkit.messageHandlers.ZRM_NATIVE_API != undefined) {
      window.webkit.messageHandlers.ZRM_NATIVE_API.postMessage(step);
    }
  }
  //Android
  if (window.ZRM_NATIVE_API != undefined) {
    window.ZRM_NATIVE_API.postMessage(step);
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function onDownloadSignedPdfHandoff(downloadLink: string, enqueueToast?: (toast: any) => void) {
  const onFileDownloadedSuccessToast = () => {
    if (enqueueToast) {
      enqueueToast(<Toast tone="success">{DOWNLOAD_TOAST_MESSAGES.LEASE_SUCCESS}</Toast>);
    }
  };

  const onFileDownloadedErrorToast = () => {
    if (enqueueToast) {
      enqueueToast(
        <Toast
          tone="critical"
          actionButton={
            <TextButton onImpact onClick={() => window.open(ZILLOW_LEASES_HELP, '_blank')}>
              Get lease help
            </TextButton>
          }
        >
          {DOWNLOAD_TOAST_MESSAGES.LEASE_ERROR}
        </Toast>,
      );
    }
  };

  //iOS & Android
  if (window.ZMOB_nativeAPI?.downloadDocument != undefined) {
    window.ZMOB_nativeAPI.downloadDocument(downloadLink);
  } else {
    downloadFileFromUrl(downloadLink)
      // eslint-disable-next-line promise/always-return
      .then(() => {
        onFileDownloadedSuccessToast();
      })
      .catch((err) => {
        logError({ error: err, context: 'onDownloadSignedPdfHandoff - download failed' });
        onFileDownloadedErrorToast();
      });
  }
}

export function isInMobileWebView() {
  const hostApp = searchParams.get('hostApp');
  const fromApp = searchParams.get('fromApp');

  return ACCEPTED_HOST_APPS.includes(hostApp) || ACCEPTED_FROM_APPS.includes(fromApp);
}

export function isInMobileFromApp() {
  const fromApp = searchParams.get('fromApp');

  return ACCEPTED_FROM_APPS.includes(fromApp);
}

export function isInMobileHostApp() {
  const hostApp = searchParams.get('hostApp');

  return ACCEPTED_HOST_APPS.includes(hostApp);
}

export function useIsInMobileWebView(): boolean {
  return useMemo(() => {
    const hostApp = searchParams.get('hostApp');
    const fromApp = searchParams.get('fromApp');
    return ACCEPTED_HOST_APPS.includes(hostApp) || ACCEPTED_FROM_APPS.includes(fromApp);
  }, []);
}
